"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptDispatcher = void 0;
class ReceiptDispatcher {
    constructor(erdstallConn) {
        this.pendingReceiptDispatchers = new Map();
        this.erdstallConn = erdstallConn;
    }
    register(hash) {
        const pendingReceipt = new Promise((resolve, reject) => {
            this.pendingReceiptDispatchers.set(hash, resolve);
        });
        return pendingReceipt;
    }
    watch(receipt) {
        if (!this.erdstallConn)
            return;
        const hash = receipt.tx.hash();
        const dispatch = this.pendingReceiptDispatchers.get(hash);
        if (dispatch) {
            dispatch(receipt);
        }
    }
}
exports.ReceiptDispatcher = ReceiptDispatcher;
//# sourceMappingURL=receipt_dispatcher.js.map